import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { CATEGORY_CONSTANTS } from "../../../../../constants/index.js";
import { MenuActionCreators } from "../../../../../redux/action-creators/index.js";
import { MenuSelectors } from "../../../../../redux/selectors/index.js";

export const useKambiNumberOfItemsMobile = () => {
  const dispatch = useDispatch();
  const numberOfDisplayedItems = useSelector(
    MenuSelectors.numberOfDisplayedItems
  );

  useEffect(() => {
    dispatch(
      MenuActionCreators.setNumberOfDisplayedItems(
        CATEGORY_CONSTANTS.NUMBER_OF_ITEMS_MOBILE_LOW
      )
    );
  }, [dispatch]);

  return numberOfDisplayedItems;
};
